import insight from './insight.js';

function v3(backendAxiosInstance) {
  return {
    ...insight(backendAxiosInstance)
  };
}

export { v3 as default };
//# sourceMappingURL=index.js.map
